import { Company, defaultCompany } from 'models'
import { allAccountsLabel, orphansLabel } from 'utils/constants'

export const ALL_ACCOUNTS_ID = '__ALL_ACCOUNTS__'
export const ORPHAN_PARENT_ID = '__ORPHAN_PARENT__'
export const MAX_SELECTED_CHILDREN = 15

export const ALL_ACCOUNTS_COMPANY: Company = {
  ...defaultCompany,
  id: ALL_ACCOUNTS_ID,
  commercialNameInt: allAccountsLabel,
}

export const ORPHAN_PARENT_COMPANY: Company = {
  ...defaultCompany,
  id: ORPHAN_PARENT_ID,
  name: orphansLabel,
  commercialNameInt: orphansLabel,
}

export const isOrphanParentOption = (company: Company | null | undefined) =>
  company?.id === ORPHAN_PARENT_ID
